export default __webpack_public_path__ + "static/media/logo_black2c.22a6d5da.webp";